var _rect, _path, _path2, _path3, _path4, _line, _line2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle, _g, _path5, _line3, _rect12, _line4, _rect13, _line5, _rect14, _line6, _rect15, _rect16, _rect17, _rect18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisualizationsBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#F7F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219 210.512L337.25 199.573L455.5 238L573.75 199.573L692 192",
    stroke: "#268FCA",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219 171.333L337.25 194.201L455.5 199L573.75 149.031L692 149",
    stroke: "#80BDE0",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219 90.4232L337.25 45L455.5 101.991L573.75 135L692 106.505",
    stroke: "#4DA3D4",
    strokeWidth: 10,
    strokeDasharray: "20 30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219 280.374L337.25 325L455.5 252L573.75 303.62L692 316.221",
    stroke: "#007BC1",
    strokeWidth: 10,
    strokeDasharray: "20 30"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 219,
    y1: 374,
    x2: 692,
    y2: 374,
    stroke: "#E2E5E5",
    strokeWidth: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 219,
    y1: 379,
    x2: 219,
    y2: 38,
    stroke: "#E2E5E5",
    strokeWidth: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 62,
    width: 35,
    height: 24,
    fill: "#D5D8DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 62,
    width: 35,
    height: 24,
    fill: "#D5D8DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 194,
    width: 35,
    height: 25,
    fill: "#D5D8DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 194,
    width: 35,
    height: 25,
    fill: "#D5D8DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 128,
    width: 35,
    height: 24,
    fill: "#D5D8DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 128,
    width: 35,
    height: 24,
    fill: "#D5D8DA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 261,
    width: 35,
    height: 24,
    fill: "#D5D8DA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 261,
    width: 35,
    height: 24,
    fill: "#D5D8DA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 327,
    width: 35,
    height: 24,
    fill: "#D5D8DA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 327,
    width: 35,
    height: 24,
    fill: "#D5D8DA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 577.5,
    cy: 198.5,
    r: 11,
    fill: "white",
    stroke: "#268FCA",
    strokeWidth: 11
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542 95H613V163.566H581.09L577.101 174L573.112 163.566H542V95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 94.5H541.5V95V163.566V164.066H542H572.768L576.634 174.179L577.101 175.4L577.568 174.179L581.434 164.066H613H613.5V163.566V95V94.5H613H542Z",
    stroke: "#424E54",
    strokeOpacity: 0.2
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578 112.5C568.34 112.5 560.5 120.34 560.5 130C560.5 139.66 568.34 147.5 578 147.5C587.66 147.5 595.5 139.66 595.5 130C595.5 120.34 587.66 112.5 578 112.5ZM576.25 138.75V128.25H579.75V138.75H576.25ZM576.25 121.25V124.75H579.75V121.25H576.25Z",
    fill: "#007BC1"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 417,
    x2: 161.682,
    y2: 417,
    stroke: "#268FCA",
    strokeWidth: 10
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 171.443,
    y: 403,
    width: 52.8691,
    height: 28,
    fill: "#D5D8DA"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 264.312,
    y1: 417,
    x2: 317.994,
    y2: 417,
    stroke: "#007BC1",
    strokeWidth: 10,
    strokeDasharray: "20 10"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 327.755,
    y: 403,
    width: 52.8691,
    height: 28,
    fill: "#D5D8DA"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 420.624,
    y1: 417,
    x2: 474.306,
    y2: 417,
    stroke: "#80BDE0",
    strokeWidth: 10
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 484.067,
    y: 403,
    width: 52.8691,
    height: 28,
    fill: "#D5D8DA"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 576,
    y1: 417,
    x2: 629.682,
    y2: 417,
    stroke: "#4DA3D4",
    strokeWidth: 10,
    strokeDasharray: "20 10"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 639,
    y: 403,
    width: 53,
    height: 28,
    fill: "#D5D8DA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 458,
    fill: "#D5D8DA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 764,
    width: 50,
    height: 458,
    fill: "#D5D8DA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 764,
    width: 10,
    height: 458,
    fill: "#B9BFC2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 541,
    y: 94,
    width: 78,
    height: 90.8005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0232986 0 0 0 0 0.14335 0 0 0 0 0.254167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizationsBanner);
export default __webpack_public_path__ + "static/media/visualizations-banner.5f4f740f08a035f085eec91ae99e37ac.svg";
export { ForwardRef as ReactComponent };